<template>
    <div ref="a4" class="blank-page">
        <template v-if="selected_signs.length == 0">
            <div v-for="index in pages" :key="index" class="wrapper" :class="{ break: index > 0 }">
                <div v-for="cell in 10" :key="cell" class="sign">
                    <SingleSaleForEightCatalogy />
                </div>
            </div>
        </template>
        <template v-else>
            <div v-for="(page, index) in pagination.pages" :key="page" class="wrapper" :class="{ break: index > 0 }">
                <template v-for="sign in pagination.signs[index]" :key="sign.duplicate_inx || sign.promoCode">
                    <div class="sign">
                        <div class="sign-tools no-see-in-print">
                            <i @click="handle_duplicate_sign(sign)" class="material-icons duplicate_icon" title="שכפול שלט">control_point_duplicate</i>
                            <i v-if="sign.is_duplicate" @click="handle_remove_duplicate_sign(sign)" class="material-icons remove_duplicate_icon" title="מחיקת שכפול">delete</i>
                        </div>
                        <SignSaleForTen :sign="sign" />
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import { is_sales_print, pagination_signs } from '../Scripts/scripts'
import { is_deleted, printer_amount, selected_deals, handle_duplicate_sign, handle_remove_duplicate_sign } from '../components/Deals/Scripts/store'
import { defineAsyncComponent, watch } from '@vue/runtime-core'

export default {
    props: ['pages', 'selected_signs'],
    components: {
        SignSaleForTen: defineAsyncComponent(() => import('./components/SignSaleForTen.vue')),
        SingleSaleForEightCatalogy: defineAsyncComponent(() => import('../components/ShilutCatalogy/SingleSaleForEightCatalogy.vue'))
    },
    setup(props) {

        const { organise_signs, pagination } = pagination_signs()

        const a4 = ref()

        /*
            עשיריית שלטים מבצע חם:
            10 שלטים בדף (2 עמודות על 5 שורות) מודפסים על נייר ממותג, ללא מסגרת.
            כל תא 10.5 ס"מ על 5.92 ס"מ. בכל שלט התוכן חייב להישאר 1.5 ס"מ מתחת לקצה העליון
            ו-0.5 ס"מ מעל הקצה התחתון, כך שנותרים 3.92 ס"מ לתוכן.
            השוליים הם padding בתוך כל תא (לא תלויים בהגדרות דיאלוג ההדפסה).
            overflow:hidden על .sign-sale (הקופסה הפנימית שממלאת בדיוק את אזור התוכן) הוא מה שמבטיח
            שהתוכן לא יחרוג לאזור השמור - חיתוך על התא עצמו נעצר רק בקצה ה-padding ולא מספיק.
        */

        const handle_print = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css';
            var css = `
        @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700&display=swap');

        * {
        direction: rtl;
        font-family: 'Rubik', sans-serif;
        font-weight: normal;
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        }

        h1 {
        font-size: inherit;
        }

        @page {
        size: A4;
        margin: 0;
        }

        @media print {
        .no-see-in-print,
        .float-icon,
        .add-icon,
        .clean-icon {
            display: none;
        }

        .break {
            page-break-before: always;
        }
        }

        .sign-tools {
        display: none;
        }

        .blank-page {
        width: 100%;
        }

        .wrapper {
        width: 100%;
        height: 29.6cm;
        display: grid;
        grid-template-columns: repeat(2, 50%);
        grid-auto-rows: 5.92cm;
        }

        .blank-page .sign {
        position: relative;
        width: 100%;
        height: 100%;
        /* אזור שמור: 1.5 ס"מ מלמעלה ו-0.5 ס"מ מלמטה בכל שלט, ללא מסגרת */
        padding: 1.5cm 0.3cm 0.5cm 0.3cm;
        border: 0;
        overflow: hidden;
        }

        /* הקופסה הפנימית ממלאת בדיוק את אזור התוכן - כל חריגה נחתכת כאן */
        .sign-sale {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        }

        /* שם המוצר - 38% מהגובה, מודגש, עד 2 שורות */
        .sign-sale-input-texts {
        position: relative;
        width: 100%;
        height: 38%;
        overflow: hidden;
        }

        .sign-sale-input-texts .he {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 0 3px;
        overflow: hidden;
        }

        .sign-name {
        font-weight: 700;
        font-size: 24px;
        line-height: 1.1;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
        }

        .sign-name.name-tier-2 {
        font-size: 22px;
        }

        .sign-name.name-tier-3 {
        font-size: 20px;
        }

        /* כמות ומחיר בשורה אחת - 28% מהגובה */
        .sign-sale-contents {
        width: 100%;
        height: 28%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        gap: 10px;
        white-space: nowrap;
        overflow: hidden;
        }

        .sign-sale-contents .col {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        }

        .sign-sale-contents .col h1 {
        font-size: 26px;
        font-weight: 700;
        }

        .sign-sale-contents .col.small h1 {
        font-size: 18px;
        font-weight: 500;
        }

        .unit {
        font-size: 14px;
        font-weight: 700;
        }

        .shekel {
        font-size: 18px;
        font-weight: 700;
        }

        /* תחתית - 34% מהגובה: מחיר רגיל, מגבלות, חברי מועדון + ברקוד */
        .sign-sale-footer {
        width: 100%;
        height: 34%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1px;
        padding: 0 3px;
        overflow: hidden;
        }

        .sign-sale-footer.item-error {
        color: red;
        font-size: 11px;
        text-align: center;
        }

        .col.price {
        width: 100%;
        display: flex;
        justify-content: center;
        }

        .col.price > small {
        font-weight: 500;
        font-size: 12px;
        line-height: 1.15;
        white-space: nowrap;
        }

        .prormo-limit {
        width: 100%;
        display: flex;
        justify-content: center;
        overflow: hidden;
        }

        .prormo-limit p {
        font-weight: 500;
        font-size: 10px;
        line-height: 1.15;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

        .prormo-limit.pl-tier-2 p {
        font-size: 9px;
        }

        .prormo-limit.pl-tier-3 p {
        font-size: 8px;
        }

        .prormo-limit.pl-tier-4 p {
        font-size: 7px;
        }

        .col.barcodes {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 3px;
        white-space: nowrap;
        overflow: hidden;
        }

        .col.barcodes h1 {
        font-size: 9px;
        font-weight: 500;
        line-height: 1.15;
        }

        [data-slice] {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

        [data-fixed] {
        display: flex;
        align-items: center;
        }

        .choos-item {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--main);
        z-index: 1000;
        }
    `;

            if (styleElem.styleSheet) {
                styleElem.styleSheet.cssText = css;
            }
            else {
                styleElem.appendChild(document.createTextNode(css));
            }

            let newWin = window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            setTimeout(() => {
                is_sales_print.value = false
                newWin.print();
            }, 1000);
        }

        const handle_print_catalogy = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css';
            var css = `
                  @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');
                  *{
                      direction:rtl;
                      font-family: 'Rubik', sans-serif;
                      font-weight:normal;
                      padding: 0;
                      margin: 0;
                      box-sizing: border-box;
                  }
                  h1{
                      font-size: inherit;
                  }
                  @media print {
                      .no-see-in-print{
                          display:none;
                      }
                      .float-icon{
                          display:none;
                      }
                      .add-icon,.clean-icon{
                          display:none;
                      }
                      .break{
                          page-break-before: always;
                      }
                  }
                  @page {
                    size: A4;
                    margin: 0;
                }
                  .blank-page{
                      width:100%;
                  }
                 .wrapper{
                      width: 100%;
                      height: 29.6cm;
                      display: grid;
                      grid-template-columns: repeat(2, 50%);
                      grid-auto-rows: 5.92cm;
                  }
                  .blank-page .sign{
                      position: relative;
                      width: 100%;
                      height: 100%;
                      padding: 1.5cm 0.3cm 0.5cm 0.3cm;
                      border: 0;
                      overflow: hidden;
                  }
                  .sign-sale{
                      width: 100%;
                      height: 100%;
                      overflow: hidden;
                  }
                  .sign-sale-header{
                      position: relative;
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      font-size: 12px;
                      border-bottom: 1px solid black;
                  }
                  .logo{
                      position: absolute;
                      width: 100px;
                      height: 100%;
                      top: 5px;
                      left: 5px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                  }
                  .logo img{
                      width: 100px;
                      height: 30px;
                  }
                  .sign-sale-input-texts{
                      position: relative;
                      width: 100%;
                      height: 35%;
                  }
                  .sign-sale-input-texts .he,.sign-sale-input-texts .ru{
                      width: 100%;
                      height: 100%;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      font-size: 14px;
                      text-align: center;
                      overflow: hidden;
                  }
                  .sign-sale-input-texts .ru{
                      font-size:10px;
                  }
                  .sign-sale-contents {
                      width: 100%;
                      height: 40%;
                      font-size: 16px;
                      display: grid;
                      place-items: center;
                      overflow: hidden;
                  }
                  .col{
                      display: flex;
                      justify-content: center;
                      align-items: center;
                  }
                  .col-1{
                      width: 10%;
                      height: 100%;
                  }
                  .col-2{
                      width: 45%;
                      height: 100%;
                  }
                  .col.barcodes{
                      justify-content:unset;
                      padding: 0 5px;
                      width: 40%;
                      font-size: 8px;
                  }
                  .col.small{
                      font-size: unset;
                      text-align: center;
                      width: 30%;
                      font-size: 14px
                  }
                   .col.price{
                      width: 30%;
                      font-size: 14px;
                      flex-direction: column;
                  }
                  .col.price > small{
                      font-weight: 500;
                      font-size: 8px;
                  }
                  [data-slice]{
                      white-space: nowrap;
                      overflow: hidden;
                      margin-right: 5px;
                  }
                  [data-fixed]{
                      display: flex;
                      align-items: center;
                  }
                  .sign-sale-footer{
                      width: 100%;
                      height: 10%;
                      display: flex;
                      font-size: 9px;
                      overflow: hidden;
                  }
              `
            if (styleElem.styleSheet) {
                styleElem.styleSheet.cssText = css;
            }
            else {
                styleElem.appendChild(document.createTextNode(css));
            }

            let newWin = window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            setTimeout(() => {
                is_sales_print.value = false
                newWin.print();
            }, 1000);
        }

        if (props.selected_signs && props.selected_signs.length > 0) {
            organise_signs(10, props.selected_signs)
        }

        printer_amount.value = []
        is_deleted.value = false
        watch(is_sales_print, () => {
            if (is_sales_print.value && props.selected_signs.length > 0) {
                setTimeout(() => {
                    handle_print()
                }, 500);
            }
            else if (is_sales_print.value && props.selected_signs.length == 0) {
                setTimeout(() => {
                    handle_print_catalogy()
                }, 500);
            }
        })

        watch(selected_deals.value, () => {
            organise_signs(10, selected_deals.value)
        })
        return {
            handle_print,
            handle_duplicate_sign,
            handle_remove_duplicate_sign,
            pagination,
            a4,
        }
    }
}
</script>

<style scoped>
.blank-page {
    width: 100%;
    min-height: 100%;
    background: #fff;
    padding: 5px;
}

.wrapper {
    width: 100%;
    height: 297mm;
    display: grid;
    grid-template-columns: repeat(2, calc(100% / 2));
    grid-auto-rows: calc(100% / 5);
}

/* תצוגה מקדימה התואמת להדפסה: 1.5 ס"מ שמורים למעלה ו-0.5 ס"מ למטה בכל שלט.
   המסגרת הדקה וקווי ההנחיה מוצגים על המסך בלבד ואינם מודפסים */
.blank-page .sign {
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid black;
    padding: 15mm 3mm 5mm 3mm;
}

.blank-page .sign::before {
    content: 'שמור 1.5 ס"מ';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 15mm;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #b5b5b5;
    font-size: 11px;
    border-bottom: 1px dashed #ff6347;
    pointer-events: none;
}

.blank-page .sign::after {
    content: 'שמור 0.5 ס"מ';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5mm;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #b5b5b5;
    font-size: 9px;
    border-top: 1px dashed #ff6347;
    pointer-events: none;
}

/* כפתורי שכפול/מחיקה - יושבים באזור השמור העליון על המסך בלבד */
.sign-tools {
    position: absolute;
    top: 0;
    right: 3mm;
    height: 15mm;
    display: flex;
    align-items: center;
    gap: 6px;
    z-index: 2;
}

.duplicate_icon,
.remove_duplicate_icon {
    cursor: pointer;
    user-select: none;
    font-size: 22px;
}

.remove_duplicate_icon {
    color: var(--danger);
}
</style>
